import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

import { EID } from '@/lib/element-ids.registry'
import { useListingAuditStatus } from '@/hooks/useListingBuilder'

import { AuditVersionSelector } from './AuditVersionSelector'
import { ListingBuilderProgress } from './ListingBuilderProgress'
import { ListingDetailTabs } from './ListingDetailTabs'

const RUNNING = new Set(['pending', 'running', 'queued', 'scraping', 'analyzing'])
const DONE = new Set(['completed', 'partial'])

export function ListingBuilderDetail() {
  const { t } = useTranslation()
  const { jobId } = useParams<{ jobId: string }>()
  const { data, refetch } = useListingAuditStatus(jobId ?? null)
  const status = data?.status

  return (
    <div id={EID['listing-builder-detail']} className="space-y-6 p-6">
      <Link
        id={EID['listing-builder-detail-back-link']}
        to="/v2/tools/listing-builder"
        className="inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('listingBuilder.detail.back')}
      </Link>

      {jobId && status && DONE.has(status) && <AuditVersionSelector jobId={jobId} />}

      {jobId && status && DONE.has(status) && <ListingDetailTabs jobId={jobId} />}

      {jobId && (!status || RUNNING.has(status)) && (
        <ListingBuilderProgress jobId={jobId} onComplete={() => refetch()} onFailed={() => refetch()} />
      )}

      {status === 'failed' && (
        <p role="alert" className="text-sm text-red-500">
          {t('listingBuilder.detail.failed')}
        </p>
      )}
    </div>
  )
}
